<template>
<el-row>
    <el-col :span="16">
        <div class="toggle" :class="{'is-collapse':isCollapse}">
            <svg t="1492500959545" @click="toggle" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1691" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64">
                <path d="M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z" p-id="1692"></path>
                <path d="M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z" p-id="1693"></path>
                <path d="M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z" p-id="1694"></path>
            </svg>
        </div>
        
    </el-col>
    <el-col :span="8" class="userinfo">

        <el-dropdown trigger="click">
            <span class="el-dropdown-link userinfo-inner">
                <img src="/static/images/avatar.png"/>{{userInfo.name}}
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <router-link to="/userinfo" class="noStyle">个人资料</router-link>
                </el-dropdown-item>
                <el-dropdown-item divided>
                    <router-link to="/login" class="noStyle">退出登录</router-link>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

    </el-col>
</el-row>
</template>

<script>
    export default {
        name: "Header",
        components: {

        },
        props: ["isCollapse", 'userInfo'],
        data() {
            return {};
        },
        computed: {},
        methods: {
            toggle() {
                this.$emit("toggle");
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*解决折叠文字的样式问题*/
    .aside-close .asideClose-hidden {
        display: none;
    }
    .aside-close .el-submenu {
        height: 56px;
        overflow: hidden;
    }
    .el-header .toggle {
        width: 50px;
        height: 50px;
        line-height: 60px;
        text-align: center;
        display: inline-block;
        vertical-align: middle;
    }
    .el-header .toggle svg {
        fill: #fff;
        display: inline-block;
        cursor: pointer;
        width: 20px;
        height: 20px;
        transform: rotate(0deg);
        transition: 0.38s;
        transform-origin: 50% 50%;
    }
    .is-collapse {
        transform: rotate(90deg);
    }
    .userinfo {
        text-align: right;
        padding-right: 35px;
        float: right;
        line-height: 50px;
    }
    .userinfo .userinfo-inner {
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        color: #fff;
    }
    .userinfo .userinfo-inner img {
        width: 39px;
        height: 39px;
        border-radius: 20px;
        margin: 6px 10px 5px 0px;
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue